module.exports = __webpack_public_path__ + "static/media/top-button-gold.2afe5045.svg";